export default __webpack_public_path__ + "static/media/OTHER_FUN_PARTY.6fb2f5b7.svg";